import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryChart,
  VictoryLine,
  VictoryTheme,
} from 'victory'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"

class TrackerSampleChart2 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: false,
      graph_config_status: 1,
      graph_type: 1,
      graph_data_show: 1,
      tracker_timeback: 1,
      tracker_day: [],
      tracker_week: [],
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    var get_tracker_day = []
    var get_tracker_week = []
    // tracker day //
    this.setState({
      tracker_day: this.getSampleData1(),
      //tracker_week: get_tracker_week,
    })
  }

  parseDate = value => {
    if (!value) {
      return null
    }

    // For API dates such as 2026-08-09T00:00:00
    if (value.indexOf('-') !== -1) {
      const datePart = value.split('T')[0]
      const parts = datePart.split('-')

      return new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      )
    }

    // For sample dates such as 09/08/26
    const parts = value.split('/')

    return new Date(
      2000 + Number(parts[2]),
      Number(parts[1]) - 1,
      Number(parts[0])
    )
  }

  formatDate = value => {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) { return '' }
    return `${date.getMonth() + 1}/${date.getDate()}`
  }

  getChartData = () => {
    return this.getTrackerSelection().data
  }

  getTrackerSelection = () => {
    const daily = [...this.state.tracker_day].sort(
      (a, b) => this.parseDate(a.date) - this.parseDate(b.date)
    )

    return {
      type: 'Daily',
      data: daily,
    }
  }

  getXAxisTicks = () => {
    const dates = this.getChartData()
      .map(item => this.parseDate(item.date))
      .filter(
        date =>
          date &&
          !Number.isNaN(date.getTime())
      )
      .sort((a, b) => a - b)

    if (dates.length === 0) {
      return []
    }

    const firstDate = new Date(dates[0])
    const lastDate = new Date(
      dates[dates.length - 1]
    )

    const ticks = []
    const currentDate = new Date(firstDate)

    while (currentDate <= lastDate) {
      ticks.push(new Date(currentDate))
      currentDate.setDate(
        currentDate.getDate() + 7
      )
    }

    return ticks
  }

  formatXAxisDate = value => {
    const date = new Date(value)

    if (Number.isNaN(date.getTime())) {
      return ''
    }

    return `${
      date.getMonth() + 1
    }/${date.getDate()}`
  }

  getSampleData1 = () => {
    const sampleData = [
      { date: '24/06/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '06/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 4.5, anxiety: 1 },
      { date: '09/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 2.5, anxiety: 1 },
      { date: '12/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 2, anxiety: 1 },
      { date: '14/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '16/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '20/07/26', mood_manic: 1, mood_depressed: 1.5, sleep: 2.5, medication: 5, exercise: 1, anxiety: 1.5 },
      { date: '24/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '29/07/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '02/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 2, medication: 5, exercise: 1, anxiety: 1 },
      { date: '08/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 3, medication: 3, exercise: 1, anxiety: 1 },
      { date: '09/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 2, medication: 5, exercise: 1, anxiety: 1 },
      { date: '11/08/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
      { date: '17/08/26', mood_manic: 1, mood_depressed: 1.5, sleep: 4, medication: 5, exercise: 4, anxiety: 1 },
      { date: '23/08/26', mood_manic: 1, mood_depressed: 1, sleep: 4, medication: 5, exercise: 1, anxiety: 1 },
    ];

    return sampleData
  }
  // Slider positions are saved as numbers. The text below describes the
  // response categories; half steps remain between adjacent categories.
  getSmallTrackerConfig = (key, type) => {
    const weekly = type === 'Weekly'
    const configs = {
      sleep: {
        title: 'Sleep (hours per day)',
        description: weekly
          ? 'Average hours slept per day, including naps, over the past week.'
          : 'Hours slept last night.',
        color: '#1e88e5',
        max: 7,
        labels: ['0–2', '3–4', '5–6', '7–8', '9–10', '11–12', '12+'],
      },
      exercise: {
        title: weekly ? 'Exercise (hours per week)' : 'Exercise (minutes per day)',
        description: weekly
          ? 'Total exercise during the past week.'
          : 'Exercise today (or yesterday if answered in the morning).',
        color: '#fb8c00',
        max: weekly ? 9 : 8,
        labels: weekly
          ? ['0–1', '1–2', '3–4', '5–6', '7–8', '9–10', '11–12', '13–14', '14+']
          : ['0', '5–10', '15–20', '25–30', '35–40', '45–50', '55–60', '60+'],
      },
      medication: {
        title: 'Medication adherence',
        description: weekly
          ? 'How much prescribed medication was taken during the past week.'
          : 'How much prescribed medication was taken today (or yesterday if answered in the morning).',
        color: '#43a047',
        max: 5,
        labels: ['None', 'Some', 'Half', 'Most', 'All'],
      },
    }
    return configs[key]
  }

  renderSmallTrackerChart = (key, type) => {
    const config = this.getSmallTrackerConfig(key, type)
    const data = this.getChartData()
      .map(row => ({ x: this.parseDate(row.date), y: Number(row[key]) }))
      .filter(point => point.x && !Number.isNaN(point.x.getTime()) &&
        Number.isFinite(point.y) && point.y >= 1 && point.y <= config.max)

    if (data.length === 0) return null

    const ticks = config.labels.map((_, index) => index + 1)
    const first = this.parseDate(this.getChartData()[0].date)
    const last = this.parseDate(this.getChartData()[this.getChartData().length - 1].date)
    // Victory needs a nonzero time span for a single response.
    const end = first.getTime() === last.getTime()
      ? new Date(last.getTime() + 24 * 60 * 60 * 1000) : last

    return (
      <div key={key} style={styles.smallChart}>
        <div style={styles.smallChartTitle}>{config.title}</div>
        <VictoryChart
          theme={VictoryTheme.material}
          height={165}
          scale={{ x: 'time' }}
          padding={{ top: 10, bottom: 39, left: key === 'medication' ? 52 : 45, right: 20 }}
          domain={{ x: [first, end], y: [0.8, config.max + 0.2] }}
        >
          <VictoryAxis
            tickValues={this.getXAxisTicks()}
            tickFormat={this.formatXAxisDate}
            style={{
              axis: { stroke: '#cccccc' },
              grid: { stroke: '#eeeeee', strokeDasharray: '4,4' },
              tickLabels: { fontSize: 7, angle: -45, textAnchor: 'end', padding: 3 },
            }}
          />
          <VictoryAxis
            dependentAxis
            tickValues={ticks}
            tickFormat={value => config.labels[value - 1] || ''}
            style={{
              axis: { stroke: '#cccccc' },
              grid: { stroke: '#eeeeee', strokeDasharray: '4,4' },
              tickLabels: { fontSize: 7, padding: 3 },
            }}
          />
          <VictoryLine
            data={data}
            style={{ data: { stroke: config.color, strokeWidth: 1.5 } }}
          />
        </VictoryChart>
      </div>
    )
  }

  render() {
    const selection = this.getTrackerSelection()
    const chartData = selection.data

    if (chartData.length === 0) {
      return (
        <div className="small-12 columns">
          Not enough tracker information to display a trend.
        </div>
      )
    }

    return (
      <div className="small-12 columns">
        <div style={styles.smallCharts}>
          {this.renderSmallTrackerChart('sleep', selection.type)}
          {this.renderSmallTrackerChart('exercise', selection.type)}
          {this.renderSmallTrackerChart('medication', selection.type)}
        </div>
      </div>
    )
  }

}

const styles = {
  smallCharts: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(235px, 1fr))',
    gap: 12,
    marginTop: 0,
    marginBottom: 40,
  },
  smallChart: {
    minWidth: 0,
  },
  smallChartTitle: {
    fontSize: 13,
    fontWeight: 600,
  },
  note: {
    marginTop: -4,
    fontSize: 11,
    color: '#607d8b',
  },

}

const mapStateToProps = (state) => {
  //console.log('Dashboard STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('Dashboard mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TrackerSampleChart2)
